import { useBookingCommerceStore } from '@/stores/bookingCommerce'
import { useBookingSelectionsStore } from '@/stores/bookingSelections'
import { useCartStore } from '@/stores/cart'
import { useCheckoutStore } from '@/stores/checkout'
import { useContentStore } from '@/stores/content'
import { useMainStore } from '@/stores/main'

/**
 * Instantiate all Pinia stores at app startup.
 *
 * Stores using `persist: true` (via pinia-plugin-persistedstate) are only
 * hydrated from localStorage when first instantiated. Without this call,
 * a persisted store that is only imported in a specific view won't exist
 * until that view loads — meaning its data is invisible after a page refresh
 * on any other route, and it won't appear in Vue DevTools.
 *
 * Call this once in main.ts after `app.use(pinia)`.
 * When adding a new store, register it here.
 */
export function initializeStores(): void {
  useMainStore()
  useBookingSelectionsStore()
  useCartStore()
  useCheckoutStore()
  useBookingCommerceStore()
  useContentStore()
}
